module.exports = __webpack_public_path__ + "static/media/Gerbera-Regular.b35fb318.otf";